import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserNotificationPreferenceModel } from '../../models/user-notification-preference.model';
import { SubSink } from 'subsink';
import { select, Store } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { selectUserPreferences } from '../../store/selectors/user-settings.selectors';
import { UserSettingsActions } from '../../store/actions/user-settings.actions';

@Component({
  selector: 'sp-user-settings-notification-tab-display',
  standalone: false,
  templateUrl: './user-settings-notification-tab-display.component.html',
  styleUrl: './user-settings-notification-tab-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSettingsNotificationTabDisplayComponent implements OnInit, OnDestroy {

  userPreferences$: Observable<UserNotificationPreferenceModel>;

  private subs = new SubSink();

  constructor(
    private store: Store<AppState>
  ) {
    this.userPreferences$ = this.store.pipe(select(selectUserPreferences));
  }

  ngOnInit(): void {
    this.store.dispatch(UserSettingsActions.loadUserNotificationPreferences());
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onUpdatePreferences(preferences: UserNotificationPreferenceModel) {
    this.store.dispatch(UserSettingsActions.updateUserNotificationPreferences({ data: preferences }));
  }
}
